angular.module('observationService', ['constants'])
.factory('observationService', function($http, $q, myConfig) {

  var service = {};

  var _baseUrl = myConfig.apiUrl + 'rings/'; //'http://127.0.0.1:8000/v1/rings/';

  /*
  * send oblist
  */
  service.sendObsList = function(data){
    var tableName = 'obslists';
    var deferred = $q.defer();
    // post if id is null
    var myMethod = (data.id == null) ? 'POST' : 'PUT';
    // get hashed name and password
    var userToken = localStorage.getItem('userToken');
    // complete url
    var url = _baseUrl + tableName;
    // send
    $http({
      method  : myMethod,
      url: url,
      data: data,
      withCredentials: true,
      headers :{'authorization':'Basic ' + userToken}
    }).then(function(response){
      deferred.resolve(response.data);
    })
    return deferred.promise;
  }

  /*
  * send ring item
  */
  service.sendObsItem = function(data){
    var tableName = 'obsitems';
    var deferred = $q.defer();
    // post if id is null
    var myMethod = (data.id == null) ? 'POST' : 'PUT';
    // get hashed name and password
    var userToken = localStorage.getItem('userToken');
    // complete url
    var url = _baseUrl + tableName;
    // send
    $http({
      method : myMethod,
      url: url,
      data: data,
      withCredentials: true,
      headers :{'authorization':'Basic ' + userToken}
    }).then(function(response){
      deferred.resolve(response.data);
    })
    return deferred.promise;
  }

  /*
  * send ring item
  */
  service.sendAdminItem = function(data){
    var tableName = 'adminobservation';
    var deferred = $q.defer();
    // post if id is null
    var myMethod = 'PUT';
    // get hashed name and password
    var userToken = localStorage.getItem('userToken');
    // complete url
    var url = _baseUrl + tableName;
    // send
    $http({
      method : myMethod,
      url: url,
      data: data,
      withCredentials: true,
      headers :{'authorization':'Basic ' + userToken}
    }).then(function(response){
      deferred.resolve(response.data);
    })
    return deferred.promise;
  }

  service.deleteMark = function(idVal){
    var tableName = 'mark';
    var deferred = $q.defer();
    var userToken = localStorage.getItem('userToken');
    var url = _baseUrl + tableName + '?id=' + idVal;
    
    $http({
      method: 'DELETE',
      url: url,
      withCredentials: true,
      headers :{'authorization':'Basic ' + userToken}
    }).then(function(response){
      deferred.resolve(response.data);
    })
    return deferred.promise;
  }

  /*
  * send ring item
  */
  service.sendForeignItem = function(data){
    var tableName = 'foreignitem';
    var deferred = $q.defer();
    // get hashed name and password
    var userToken = localStorage.getItem('userToken');
    // complete url
    var url = _baseUrl + tableName;
    // send
    $http({
      method : 'POST',
      url: url,
      data: data,
      withCredentials: true,
      headers :{'authorization':'Basic ' + userToken}
    }).then(function(response){
      deferred.resolve(response.data);
    })
    return deferred.promise;
  }

  /*
  * send ring item
  */
  service.sendAdminObservation = function(data){
    var tableName = 'adminobservation';
    var deferred = $q.defer();
    // get hashed name and password
    var userToken = localStorage.getItem('userToken');
    // complete url
    var url = _baseUrl + tableName;
    // send
    $http({
      method : 'POST',
      url: url,
      data: data,
      withCredentials: true,
      headers :{'authorization':'Basic ' + userToken}
    }).then(function(response){
      deferred.resolve(response.data);
    })
    return deferred.promise;
  }

  /*
  * send simple admin item
  */
  service.checkRingAvailable = function(data){
    var tableName = 'checkringavailable';
    var deferred = $q.defer();
    // get hashed name and password
    var userToken = localStorage.getItem('userToken');
    // complete url
    var url = _baseUrl + tableName;
    // send
    $http({
      method : 'POST',
      url: url,
      data: data,
      withCredentials: true,
      headers :{'authorization':'Basic ' + userToken}
    }).then(function(response){
      deferred.resolve(response.data);
    })
    return deferred.promise;
  }

  /*
  * send simple admin item
  */
  service.sendSimpleAdminObservation = function(data){
    var tableName = 'adminobservationsimple';
    var deferred = $q.defer();
    // get hashed name and password
    var userToken = localStorage.getItem('userToken');
    // complete url
    var url = _baseUrl + tableName;
    // send
    $http({
      method : 'POST',
      url: url,
      data: data,
      withCredentials: true,
      headers :{'authorization':'Basic ' + userToken}
    }).then(function(response){
      deferred.resolve(response.data);
    })
    return deferred.promise;
  }

  service.closeObsItems = function(data){
    var url = myConfig.apiUrl + 'main/list';
    url = url +'?id=Id';
    var deferred = $q.defer();
    var userToken = localStorage.getItem('userToken');

    $http({
      method : 'PUT',
      url: url,
      data: data,
      withCredentials: true,
      headers :{'authorization':'Basic ' + userToken}
    }).then(function(response){
      deferred.resolve(response.data);
    })
    return deferred.promise;
  }

   // get obsitem with given id
  service.getRetrapCoordinates = function(id){
    var tableName = 'retrapcoordinates';
    var additionalUrl = '?ringingId=' + id;// + '&withList=true';
    var deferred = $q.defer();
    // escape the user name
    var userToken = localStorage.getItem('userToken');
    var url = _baseUrl + tableName + additionalUrl;
    $http({
      method: 'GET',
      url: url,
      withCredentials: true,
      headers :{'authorization':'Basic ' + userToken}
    }).then(function(response){
      deferred.resolve(response.data);
    })
    return deferred.promise;
  }

  // get obsitem with given id
  service.getObsItem = function(id){
    var tableName = 'obsitems';
    var additionalUrl = '?id=' + id;// + '&withList=true';
    var deferred = $q.defer();
    // escape the user name
    var userToken = localStorage.getItem('userToken');
    var url = _baseUrl + tableName + additionalUrl;
    $http({
      method: 'GET',
      url: url,
      withCredentials: true,
      headers :{'authorization':'Basic ' + userToken}
    }).then(function(response){
      deferred.resolve(response.data);
    })
    return deferred.promise;
  }

   // get obsitem with given id
  service.getOpenObsList2 = function(id){
    var tableName = 'vw_observation_detail_simplified';
    var additionalUrl = '?id=' + id;// + '&withList=true';
    var deferred = $q.defer();
    // escape the user name
    var userToken = localStorage.getItem('userToken');
    var url = _baseUrl + tableName + additionalUrl;
    $http({
      method: 'GET',
      url: url,
      withCredentials: true,
      headers :{'authorization':'Basic ' + userToken}
    }).then(function(response){
      deferred.resolve(response.data);
    })
    return deferred.promise;
  }

  service.getOpenObsList = function(){
    var tableName = 'obslists';
    var deferred = $q.defer();
    // escape the user name
    var userToken = localStorage.getItem('userToken');
    var url = _baseUrl + tableName;
    $http({
      method: 'GET',
      url: url,
      withCredentials: true,
      headers :{'authorization':'Basic ' + userToken}
    }).then(function(response){
      deferred.resolve(response.data);
    })
    return deferred.promise;
  }

  service.getObservationDetail = function(id){
    var tableName = 'vw_observation_detail';
    var additionalUrl = '?id=' + id;
    var deferred = $q.defer();
    // escape the user name
    var userToken = localStorage.getItem('userToken');
    var url = _baseUrl + tableName + additionalUrl;
    $http({
      method: 'GET',
      url: url,
      withCredentials: true,
      headers :{'authorization':'Basic ' + userToken}
    }).then(function(response){
      deferred.resolve(response.data);
    })
    return deferred.promise;
  }

  service.getHistoryDetail = function(additionalUrl){
    var tableName = 'vw_history_detail'; 
    var deferred = $q.defer();
    // escape the user name
    var userToken = localStorage.getItem('userToken');
    var url = _baseUrl + tableName + additionalUrl;
    $http({
      method: 'GET',
      url: url,
      withCredentials: true,
      headers :{'authorization':'Basic ' + userToken}
    }).then(function(response){
      deferred.resolve(response.data);
    })
    return deferred.promise;
  }

  /*
  * when user is searching for history of his own retrap
  */
  service.getRingingHistoryDetail = function(additionalUrl){
    var tableName = 'vw_ringing_history_detail';
    var deferred = $q.defer();
    // escape the user name
    var userToken = localStorage.getItem('userToken');
    var url = _baseUrl + tableName + additionalUrl;
    $http({
      method: 'GET',
      url: url,
      withCredentials: true,
      headers :{'authorization':'Basic ' + userToken}
    }).then(function(response){
      deferred.resolve(response.data);
    })
    return deferred.promise;
  }

  /*
  * get summary of users activity for a year
  */
  service.fetchSummary = function(additionalUrl){
    var deferred = $q.defer();
    var tableName = 'vw_summary';
    var userToken = localStorage.getItem('userToken');
    var url = _baseUrl + tableName + "?" + additionalUrl;
    $http({
      method: 'GET',
      url: url,
      withCredentials: true,
      headers :{'authorization':'Basic ' + userToken}
    }).then(function(response){
      deferred.resolve(response.data);
    })
    return deferred.promise;
  }


  /*
  * get list of items for a user
  */
  service.fetchUserRetraps = function(numPage,numRecordsPerPage,where){
    var tableName = 'vw_user_retrap';
    var additionalUrl = '?withCount=true'
    var deferred = $q.defer();
    if (typeof where != 'undefined'){
      additionalUrl += '&' + where;
    }
    additionalUrl += '&numPage=' + numPage;
    additionalUrl += '&numRecordsPerPage=' + numRecordsPerPage;
    var userToken = localStorage.getItem('userToken');
    var url = _baseUrl + tableName + additionalUrl;
    $http({
      method: 'GET',
      url: url,
      withCredentials: true,
      headers :{'authorization':'Basic ' + userToken}
    }).then(function(response){
      deferred.resolve(response.data);
    })
    return deferred.promise;
  }

  /*
  * get list of items for a user
  */
  service.fetchObservationOverview = function(numPage,numRecordsPerPage,where){
    var tableName = 'vw_observation';
    var additionalUrl = '?withCount=true'
    var deferred = $q.defer();
    if (typeof where != 'undefined'){
      additionalUrl += '&' + where;
    }
    additionalUrl += '&numPage=' + numPage;
    additionalUrl += '&numRecordsPerPage=' + numRecordsPerPage;
    var userToken = localStorage.getItem('userToken');
    var url = _baseUrl + tableName + additionalUrl;
    $http({
      method: 'GET',
      url: url,
      withCredentials: true,
      headers :{'authorization':'Basic ' + userToken}
    }).then(function(response){
      deferred.resolve(response.data);
    })
    return deferred.promise;
  }

  /* 
  * full observation overview for history
  */
  service.fetchFullObservationOverview = function(where){
    var tableName = 'vw_observation_export';
    var additionalUrl = '?' + where;
    var userToken = localStorage.getItem('userToken');
    var url = _baseUrl + tableName + additionalUrl;
    var deferred = $q.defer();
    $http({
      method: 'GET',
      url: url,
      withCredentials: true,
      headers :{'authorization':'Basic ' + userToken}
    }).then(function(response){
      deferred.resolve(response.data);
    })
    return deferred.promise;
  }

  /*
  * get ringing history
  */
  service.fetchObservationHistory = function(numPage,numRecordsPerPage,where){
    var tableName = 'vw_observation_history';
    var additionalUrl = '?withCount=true'
    var deferred = $q.defer();
    if (typeof where !== 'undefined'){
      additionalUrl += '&' + where;
    }
    additionalUrl += '&numPage=' + numPage;
    additionalUrl += '&numRecordsPerPage=' + numRecordsPerPage;
    var userToken = localStorage.getItem('userToken');
    var url = _baseUrl + tableName + additionalUrl;
    $http({
      method: 'GET',
      url: url,
      withCredentials: true,
      headers :{'authorization':'Basic ' + userToken}
    }).then(function(response){
      deferred.resolve(response.data);
    })
    return deferred.promise;
  }
  
  /*
  * get species report
  */
  /*service.fetchSpeciesReport = function(additionalUrl){

    var tableName = 'reports';
    var deferred = $q.defer();
    var userToken = localStorage.getItem('userToken');
    var url = _baseUrl + tableName + additionalUrl;
    $http({
      method: 'GET',
      url: url,
      withCredentials: true,
      headers :{'authorization':'Basic ' + userToken}
    }).then(function(response){
      deferred.resolve(response.data);
    })
    return deferred.promise;
  }*/

  /*
  * get species report 2
  */
  service.fetchSpeciesReport = function(additionalUrl){

    var tableName = 'reports';
    var deferred = $q.defer();
    var userToken = localStorage.getItem('userToken');
    var url = _baseUrl + tableName + additionalUrl;
    $http({
      method: 'GET',
      url: url,
      withCredentials: true,
      headers :{'authorization':'Basic ' + userToken}
    }).then(function(response){
      deferred.resolve(response.data);
    })
    return deferred.promise;
  }

  /*
  * delete ring item
  */
  service.deleteRingItem = function(additionalUrl){

    var tableName = 'obsitems';
    var deferred = $q.defer();
    var userToken = localStorage.getItem('userToken');
    var url = _baseUrl + tableName + additionalUrl;
    $http({
      method: 'DELETE',
      url: url,
      withCredentials: true,
      headers :{'authorization':'Basic ' + userToken}
    }).then(function(response){
      deferred.resolve(response.data);
    })
    return deferred.promise;
  }

  service.deleteObsList = function(idVal){
    var tableName = 'obslists';
    var deferred = $q.defer();
    var userToken = localStorage.getItem('userToken');
    var url = _baseUrl + tableName + '?id=' + idVal;
    $http({
      method: 'DELETE',
      url: url,
      withCredentials: true,
      headers :{'authorization':'Basic ' + userToken}
    }).then(function(response){
      deferred.resolve(response.data);
    })
    return deferred.promise;
  }

  /*fetch retraps*/
   service.fetchRetraps = function(numPage,numRecordsPerPage,where){
    var tableName = 'vw_retrap_overview';
    var additionalUrl = '?withCount=true'
    var deferred = $q.defer();
    if (typeof where != 'undefined'){
      additionalUrl += '&' + where;
    }
    additionalUrl += '&numPage=' + numPage;
    additionalUrl += '&numRecordsPerPage=' + numRecordsPerPage;
    var userToken = localStorage.getItem('userToken');
    var url = _baseUrl + tableName + additionalUrl;
    $http({
      method: 'GET',
      url: url,
      withCredentials: true,
      headers :{'authorization':'Basic ' + userToken}
    }).then(function(response){
      deferred.resolve(response.data);
    })
    return deferred.promise;
  }

   /*fetch retraps*/
   service.fetchRetrapItems = function(where){
    var tableName = 'retrapitem';
    var userToken = localStorage.getItem('userToken');
    var deferred = $q.defer();
    var url = _baseUrl + tableName + where;
    $http({
      method: 'GET',
      url: url,
      withCredentials: true,
      headers :{'authorization':'Basic ' + userToken}
    }).then(function(response){
      deferred.resolve(response.data);
    })
    return deferred.promise;
  }

  /*
  * get list of items for a user
  */
  service.fetchRetrapHistory = function(ringCode,ringingScheme,identMethod,colour,id,reringing,taxonid){

    var tableName = 'vw_retrap';
    
    var additionalUrl = "?code=" + ringCode + "&scheme=" + ringingScheme + "&taxon=" + taxonid + "&method="+identMethod + "&color="+colour+"&id="+id+"&reringing="+reringing;
    var deferred = $q.defer();
    var userToken = localStorage.getItem('userToken');
    var url = _baseUrl + tableName + additionalUrl;
    $http({
      method: 'GET',
      url: url,
      withCredentials: true,
      headers :{'authorization':'Basic ' + userToken}
    }).then(function(response){
      deferred.resolve(response.data);
    })
    return deferred.promise;
  }

  /*
  * get list of items for a user
  */
  service.generateRetrapPdf = function(body){
    //console.log(body);
    var tableName = 'vw_retrap';
    var deferred = $q.defer();
    var userToken = localStorage.getItem('userToken');
    var url = _baseUrl + tableName;
    $http({
      method: 'POST',
      url: url,
      data: body,
      withCredentials: true,
      headers :{'authorization':'Basic ' + userToken}
    }).then(function(response){
      deferred.resolve(response.data);
    })
    return deferred.promise;
  }

  // request ringing data
  service.sendEmail = function(data){
    var tableName = 'send_mail';
    var deferred = $q.defer();
    var userToken = localStorage.getItem('userToken');
    var url = _baseUrl + tableName;
    $http({
      method: 'POST',
      url: url,
      data: data,
      withCredentials: true,
      headers :{'authorization':'Basic ' + userToken}
    }).then(function(response){
      deferred.resolve(response.data);
    })
    return deferred.promise;
  }

  /*
  * get list of items for a user
  */
  service.fetchRingItem = function(additionalUrl){

    var tableName = 'vw_retrap_admin';
    var deferred = $q.defer();
    var userToken = localStorage.getItem('userToken');
    var url = _baseUrl + tableName + additionalUrl;
    $http({
      method: 'GET',
      url: url,
      withCredentials: true,
      headers :{'authorization':'Basic ' + userToken}
    }).then(function(response){
      deferred.resolve(response.data);
    })
    return deferred.promise;
  }

  // update RingItem
  service.updateRingItem = function(data){
    var tableName = 'ringitem';
    var deferred = $q.defer();
    var userToken = localStorage.getItem('userToken');
    var url = _baseUrl + tableName;
    $http({
      method: 'PUT',
      url: url,
      data: data,
      withCredentials: true,
      headers :{'authorization':'Basic ' + userToken}
    }).then(function(response){
      deferred.resolve(response.data);
    })
    return deferred.promise;
  }

  // update RingItem
  service.updateRetrapItem = function(data,withRingItem,additionalUrl){
    var tableName = 'retrapitem'; 
    var deferred = $q.defer();
    var userToken = localStorage.getItem('userToken');
    var url = _baseUrl + tableName;
    if (withRingItem){
      url += '?withRingItem=true';
      if (additionalUrl){
        url += '&'+additionalUrl;
      }
    } else {
      if (additionalUrl){
        url += '?'+additionalUrl;
      }
    }
    $http({
      method: 'PUT',
      url: url,
      data: data,
      withCredentials: true,
      headers :{'authorization':'Basic ' + userToken}
    }).then(function(response){
      deferred.resolve(response.data);
    })
    return deferred.promise;
  }


  service.updateObsItem = function(data){
    var tableName = 'obsitems';
    var deferred = $q.defer();
    var userToken = localStorage.getItem('userToken');
    var url = _baseUrl + tableName + '?raw&id=Id';
    $http({
      method: 'PUT',
      url: url,
      data: data,
      withCredentials: true,
      headers :{'authorization':'Basic ' + userToken}
    }).then(function(response){
      deferred.resolve(response.data);
    })
    return deferred.promise;
  }

    /*
  * get chart data report
  */
  service.fetchChartData = function(additionalUrl){
    var tableName = 'vw_chart_data';
    var deferred = $q.defer();
    var userToken = localStorage.getItem('userToken');
    var url = _baseUrl + tableName + additionalUrl;
    $http({
      method: 'GET',
      url: url,
      withCredentials: true,
      headers :{'authorization':'Basic ' + userToken}
    }).then(function(response){
      deferred.resolve(response.data);
    })
    return deferred.promise;
  }

  return service;

});
